<lx-form-field-selector
  [small]="small"
  [label]="label"
  [disabled]="disabled"
  [value]="value"
  valueExpr="code"
  [itemList]="nationalities"
  [sortCriteria]="sortCriteria"
  [buttonView]="false"
  [placeholder]="placeholder"
  [required]="required"
  [iconValidation]="true"
  (valueChange)="dirty = true; valueChange.emit($event)"
  (dropdownClosed)="dropdownClosed.emit()"
></lx-form-field-selector>
